const mptee = () => {
    return (
        <p>
            <br /><b>Частота:</b> 4.0-13.0 МГц<br /><b>Угол обзора:</b> 90°
            <br /><b>Толщина:</b> 10 мм<br /><b>Длина:</b> 100 мм<br />
            <b>Клиническое применение:</b> чреспищеводные кардиологические исследования
            <br /><br />            
        </p>
    );
}

export default mptee;